import { object, SchemaOf } from 'yup';
import { ProjectShape } from '../../schemas/Project.schemas';
import { ProjectFormContentType } from './ProjectForm.types';

export const ProjectFormSchema: SchemaOf<ProjectFormContentType> = object({
  ...ProjectShape,
});
